import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { FilesModule } from '@core/components/files/files.module';
import { CoreStorageModule } from '@core/components/storage/storage.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillFilesV1FieldComponent } from './fill-files-v1/fill-files-v1.component';
import { ViewFilesV1FieldComponent } from './view-files-v1/view-files-v1.component';
import { SettingsFilesV1FieldComponent } from './settings-files-v1/settings-files-v1.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        FilesModule,
        CoreStorageModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillFilesV1FieldComponent,
        ViewFilesV1FieldComponent,
        SettingsFilesV1FieldComponent
    ],
    exports: [
        FillFilesV1FieldComponent,
        ViewFilesV1FieldComponent,
        SettingsFilesV1FieldComponent
    ],

})
export class CoreCustomFormsFieldFilesV1FieldsModule { }
